import { useState } from "react";
import "../../styles/projects-page.css";

const ProjectsPage = () => {
    const [filter, setFilter] = useState("all");

    const projects = [
        {
            id: "im-academy",
            title: "Mobile App for IM Academy",
            category: "mobile",
            description: "A comprehensive mobile trading education platform with real-time market data and interactive learning modules.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["React Native", "Node.js", "AWS"]
        },
        {
            id: "real-rise",
            title: "Customer Portal for Real Rise",
            category: "web",
            description: "A full-featured customer management portal with analytics dashboard, reporting tools, and automated workflows.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["React", "Firebase", "Tailwind"]
        },
        {
            id: "4you-attorneys",
            title: "Full Suite for 4you Attorneys",
            category: "web",
            description: "Complete digital transformation including website, client portal, case management system, and document automation.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/642363c47c68c82b957e2b6d_billboard-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["Next.js", "PostgreSQL", "Stripe"]
        },
        {
            id: "myaccidentexperts",
            title: "Full Suite for MyAccidentExperts",
            category: "web",
            description: "End-to-end legal tech solution with client intake forms, case tracking, and automated communication systems.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423614f099312f269d37119_stationary-design-for-globex-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["Vue.js", "Node.js", "MongoDB"]
        },
        {
            id: "fintech-dashboard",
            title: "FinTech Analytics Dashboard",
            category: "web",
            description: "Real-time financial analytics platform with customizable widgets, data visualization, and automated reporting.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["React", "D3.js", "Python"]
        },
        {
            id: "ecommerce-platform",
            title: "E-Commerce Platform",
            category: "web",
            description: "Scalable multi-vendor marketplace with inventory management, payment processing, and logistics integration.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
            tags: ["Shopify", "React", "GraphQL"]
        }
    ];

    const categories = [
        { id: "all", label: "All Projects" },
        { id: "web", label: "Web Apps" },
        { id: "mobile", label: "Mobile Apps" },
    ];

    const filteredProjects = filter === "all" 
        ? projects 
        : projects.filter(p => p.category === filter);

    return (
        <div className="projects-page">
            {/* Hero Section */}
            <section className="projects-hero">
                <div className="container-default w-container">
                    <div className="projects-hero-content">
                        <div className="big-font-title display-2---size">Portfolio</div>
                        <h1 className="display-1">Our Projects</h1>
                        <p className="projects-hero-subtitle">
                            Explore our portfolio of successful digital solutions. Each project represents 
                            our commitment to excellence and innovation.
                        </p>
                    </div>
                </div>
            </section>

            {/* Filter Bar */}
            <section className="projects-filter-section">
                <div className="container-default w-container">
                    <div className="projects-filter-bar">
                        {categories.map(cat => (
                            <button
                                key={cat.id}
                                className={`projects-filter-btn ${filter === cat.id ? 'active' : ''}`}
                                onClick={() => setFilter(cat.id)}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Projects Grid */}
            <section className="projects-grid-section">
                <div className="container-default w-container">
                    <div className="projects-grid">
                        {filteredProjects.map((project, index) => (
                            <a 
                                key={project.id}
                                href={`/projects/${project.id}`}
                                className="project-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="project-card-image-wrapper">
                                    <img 
                                        src={project.image} 
                                        alt={project.title}
                                        className="project-card-image"
                                    />
                                    <div className="project-card-overlay">
                                        <span className="project-card-view">View Project</span>
                                    </div>
                                </div>
                                <div className="project-card-content">
                                    <h3 className="project-card-title">{project.title}</h3>
                                    <p className="project-card-description">{project.description}</p>
                                    <div className="project-card-tags">
                                        {project.tags.map(tag => (
                                            <span key={tag} className="project-card-tag">{tag}</span>
                                        ))}
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="projects-cta-section">
                <div className="container-default w-container">
                    <div className="projects-cta-content">
                        <h2 className="display-3">Have a project in mind?</h2>
                        <p>Let's discuss how we can bring your vision to life.</p>
                        <a href="/contact" className="btn-secondary w-button">Start a Project</a>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ProjectsPage
